import { isQuoteLineItem } from '@printdeal/business-logic';
import { SanitizedLineItem } from '../../../../../../types/order/Order';
// @ts-expect-error
import { reOrderableQuote } from '../../../../../../helpers/order/Order';
import { useOrderQuotesValidation } from '../../../hooks/useOrders';

const ReasonsDisabled = {
  NOT_QUOTE_LINEITEM: 'Not Quote Lineitem',
  QUOTE_NOT_EXPIRED: 'Quote not expired',
};

const useExtendQuote = (lineItem: SanitizedLineItem) => {
  if (!isQuoteLineItem(lineItem)) {
    return {
      enable: false,
      reasonDisabled: ReasonsDisabled.NOT_QUOTE_LINEITEM,
    };
  }

  const quoteValidationResults = useOrderQuotesValidation([lineItem]);
  if (reOrderableQuote(lineItem, quoteValidationResults)) {
    return {
      enable: false,
      reasonDisabled: ReasonsDisabled.QUOTE_NOT_EXPIRED,
    };
  }

  return {
    enabled: true,
  };
};

export default useExtendQuote;
